import { FC, useEffect, useMemo, useState } from 'react';
import { InfiniteScrollLoading } from 'components/InfiniteScrollLoading';
import { Order } from 'types/graphql';
import { Card } from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/views/OpenShifts/Card';
import { ShiftsTableRowInfoWrapper } from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/RemovePositionModal.styled';
import { useOpenShiftsDataContext } from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/views/OpenShifts/OpenShifts.data.context';

const mergeOpenShiftsNodes = (existingNodes: Order[], incomingNodes: Order[]) => {
  const nextNodes = [...existingNodes];
  if (incomingNodes?.length > 0)
    incomingNodes.forEach((record) => {
      if (record && record.id)
        if (!nextNodes.some(({ id }) => record.id === id)) nextNodes.push(record);
    });
  return nextNodes;
};
export const OpenShiftsListCards: FC = () => {
  const { data, loadMore } = useOpenShiftsDataContext();

  const [openShiftsListData, setOpenShiftsData] = useState<Order[]>([]);

  const pageInfo = useMemo(() => {
    const info = data?.fetchPosition?.configuredShifts?.pageInfo;
    return info || {};
  }, [data?.fetchPosition?.configuredShifts?.pageInfo]);

  useEffect(() => {
    if (
      data &&
      data?.fetchPosition?.configuredShifts?.nodes &&
      data?.fetchPosition?.configuredShifts?.nodes.length
    ) {
      const lastElementFromApi = data?.fetchPosition?.configuredShifts?.nodes.slice(-1)[0];
      if (
        openShiftsListData.length === 0 ||
        lastElementFromApi?.id !== openShiftsListData?.slice(-1)[0]?.id
      ) {
        setOpenShiftsData(
          mergeOpenShiftsNodes(
            openShiftsListData,
            data?.fetchPosition?.configuredShifts?.nodes as Order[],
          ),
        );
      }
    }
  }, [data, openShiftsListData]);

  if (!data) return null;
  if (!data?.fetchPosition) return null;
  if (!data?.fetchPosition?.configuredShifts?.nodes) return null;

  return (
    <ShiftsTableRowInfoWrapper flexDirection="column" padding="16px 32px">
      {(openShiftsListData as Order[]).map((node, i) => node && <Card key={i} order={node} />)}
      {!!pageInfo.hasNextPage && loadMore ? (
        <InfiniteScrollLoading onViewportEnter={loadMore} />
      ) : null}
    </ShiftsTableRowInfoWrapper>
  );
};
